export default __webpack_public_path__ + "static/media/portfolio-81.a91654b2.jpg";